import React, { useContext } from "react";
import styled from "styled-components";
import { NavLink, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faBuilding, faHome } from "@fortawesome/free-solid-svg-icons";
import { AppContext } from "../Utils/AppContext";
import BlyncSyncLogo from "../Base/BlyncSyncLogo";

const SideNav = () => {
  const context = useContext(AppContext);
  const currentUser = context.state.user;

  return (
    <SideBar>
      <HomeLogoLink>
        <Link to="/">
          <BlyncSyncLogo color="blue" />
          <h1>BlyncSync</h1>
        </Link>
      </HomeLogoLink>

      <MainNavigation>
        <ul>
          {currentUser.role === "super" && (
            <li>
              <NavLink exact to="/">
                <FontAwesomeIcon icon={faBuilding} />
                Companies
              </NavLink>
            </li>
          )}

          <li>
            <NavLink exact to="/fleets">
              <FontAwesomeIcon icon={faUsers} />
              Fleets
            </NavLink>
          </li>

          <li>
            <NavLink exact to="/drivers">
              <FontAwesomeIcon icon={faUser} />
              Drivers
            </NavLink>
          </li>

          {currentUser.role === "company-manager" && (
            <li>
              <NavLink exact to="/company">
                <FontAwesomeIcon icon={faBuilding} />
                Company Settings
              </NavLink>
            </li>
          )}

          {currentUser.role === "super" && (
            <li>
              <NavLink exact to="/managers">
                <FontAwesomeIcon icon={faUser} />
                Managers
              </NavLink>
            </li>
          )}
        </ul>
      </MainNavigation>
    </SideBar>
  );
};

const SideBar = styled.div`
  // background: #488aff;
  display: flex;
  flex-direction: column;
  height: 100vh;
  border-right: solid 1px #eaedf3;
`;

const HomeLogoLink = styled.div`
  padding: 14px 60px;
  border-bottom: solid 1px #eaedf3;

  a {
    display: flex;
    align-items: center;
    color: #3e3f42;
    text-decoration: none;

    img {
      width: 34px;
      height: 38px;
    }

    h1 {
      font-size: 19px;
      margin-left: 8px;
    }
  }
`;

const MainNavigation = styled.div`
  ul {
    padding: 10px 30px 10px;

    li {
      a {
        display: flex;
        align-items: center;
        padding: 22px 0;
        border-bottom: solid 1px #eaedf3;
        font-size: 14px;
        font-weight: 500;
        text-decoration: none;
        color: #3e3f42;

        &.active {
          color: #488aff;
        }

        svg {
          height: 18px;
          width: 18px;
          margin-right: 8px;
        }
      }
    }
  }
`;

export default SideNav;
